import React  from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Loader from '../components/common/Loader';
import { getLoading } from '../reducers/loading';

const SpinnerWrapper = () => WrappedComponent => {
  const SpinnerControl = (props) => {
    if (props.loading) {
      return <Loader fullScreen />;
    }
    return <WrappedComponent {...props} />;
  }

  SpinnerControl.propTypes = {
    loading: PropTypes.bool,
  };

  const mapStateToProps = state => ({
    loading: getLoading(state),
  });

  return connect(mapStateToProps)(SpinnerControl);
};

export default SpinnerWrapper;
